import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Row, Col, Card, CardBody } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import './chooseCategory.scss';

const categories = [
  {
    key: 'Waqf',
    icon: 'ri-bank-line',
    title: 'Waqf',
    description: 'Registered under Waqf Board',
  },
  {
    key: 'Trust',
    icon: 'ri-shield-check-line',
    title: 'Trust',
    description: 'Registered Trust Organization',
  },
  {
    key: 'UnRegistered',
    icon: 'ri-file-warning-line',
    title: 'Un Registered',
    description: 'Not registered under any authority',
  },
];

const ChooseCategory: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const mazarName = searchParams.get('mazar_name') || '';

  const handleSelect = (category: string) => {
    navigate(
      category === 'UnRegistered'
        ? `/organizations/${id}/lands?mazar_name=${mazarName}&category=unregistered`
        : `/organizations/${id}/registration-board?mazar_name=${mazarName}&category=${category}`,
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <BreadCrumb
          title="Choose Category"
          breadcrumbItems={[
            { label: 'Dashboard', path: '/dashboard' },
            { label: mazarName, path: '/organizations' },
            { label: 'Choose Category', isActive: true },
          ]}
        />

        <div className="text-center mb-4">
          <h4 className="fw-semibold">
            What type of property are you managing?
          </h4>
          <p className="text-muted w-50 mx-auto">
            Select one of the categories below to continue. Choosing the right
            category helps us tailor the forms, legal details and workflows
            specifically for <strong>Waqf-registered</strong>,{' '}
            <strong>Trust-registered</strong> or <strong>Un-Registered</strong>{' '}
            properties.
          </p>
        </div>

        <Row className="justify-content-center mt-4">
          {categories.map(card => (
            <Col key={card.key} xl={3} md={4} sm={6} className="mb-4">
              <Card
                className="text-center h-100 shadow-sm choose-category-card"
                onClick={() => handleSelect(card.key)}
                role="button"
              >
                <CardBody className="d-flex flex-column align-items-center justify-content-center p-4">
                  <div className="avatar-xl mb-3 bg-light rounded-circle d-flex align-items-center justify-content-center">
                    <i className={`${card.icon} h1 mb-0 text-primary`}></i>
                  </div>
                  <h5 className="mb-2">{card.title}</h5>
                  <p className="text-muted mb-0 text-center small">
                    {card.description}
                  </p>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </React.Fragment>
  );
};

export default ChooseCategory;
